/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  RDSetupTitle: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDSetupTitle',
    defaultMessage: 'RD',
  },
  RDProjectNumber: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDProjectNumber',
    defaultMessage: 'RD Project Number',
  },
  RDProgramType: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDProgramType',
    defaultMessage: 'RD Program Type',
  },
  RDProjectName: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDProjectName',
    defaultMessage: 'RD Project Name',
  },
  RDProjectType: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDProjectType',
    defaultMessage: 'RD Project Type',
  },
  RDProjectRentalTypes: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDProjectRentalTypes',
    defaultMessage: 'RD Project Rental Type',
  },
  RDBorrowerId: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDBorrowerId',
    defaultMessage: 'Borrower ID',
  },
  loanTransferAmount: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.loanTransferAmount',
    defaultMessage: 'Loan/Transfer Amount',
  },
  noteRentPayment: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.noteRentPayment',
    defaultMessage: 'Note Rent Payment',
  },
  icPayment: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.icPayment',
    defaultMessage: 'IC Payment',
  },
  RDRentalAssistance: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDRentalAssistance',
    defaultMessage: 'Rental Assistance (RA)',
  },
  RDTotalRAUnits: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDTotalRAUnits',
    defaultMessage: 'Total # of RA Units',
  },
  RD538Loan: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RD538Loan',
    defaultMessage: 'Property has a 538 Loan',
  },
  reserveAccountRequiredBalance: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.reserveAccountRequiredBalance',
    defaultMessage: 'Reserve Account Required Balance',
  },
  contractEffectiveDate: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.contractEffectiveDate',
    defaultMessage: 'Contract Effective Date',
  },
  contractExpirationDate: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.contractExpirationDate',
    defaultMessage: 'Contract Expiration Date',
  },
  expirationBeforeEffectiveDate: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.expirationBeforeEffectiveDate',
    defaultMessage: 'Expiration date cannot be before effective date.',
  },
  RDNYContractNumber: {
    id: 'App.ViewProperty.AffordableSetup.RDSetup.RDNYContractNumber',
    defaultMessage: 'NY State Contract #',
  },
});

export default messages;
